module.exports = __webpack_public_path__ + "static/media/wizard-suggestions.aade102c.svg";